var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Room.AnchorDisabledGet",
    "options": {
        "java_package": "com.asiainno.uplive.proto",
        "objc_class_prefix": "RoomAnchorDisabledGet"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomId",
                    "id": 1
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "optional",
                    "type": "Status",
                    "name": "status",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "disabledDesc",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "liveTimes",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "moneyTotal",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "peoples",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "likeNum",
                    "id": 6
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "Status",
            "values": [
                {
                    "name": "OPEN",
                    "id": 0
                },
                {
                    "name": "DISABLED",
                    "id": 1
                },
                {
                    "name": "FORCE_DISABLED",
                    "id": 2
                }
            ]
        }
    ]
}).build();


export default _root;


// WEBPACK FOOTER //
// ./js/living/view/exception/disabled.pb.js